<template>
  <div>
    <v-card>
      <v-card-text>
        <v-layout align-center>
          <v-flex>
            <v-btn
              slot="button-prev"
              class="button-prev"
              flat
              icon
            >
              <v-icon>chevron_left</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs10>
            <swiper :options="swiperOption">
              <swiper-slide
                v-for="(point, index) in timelinePoints"
                :key="index"
              >
                <drag
                  class="timeline-point"
                  @dragstart="dragStart(index)"
                  @dragend="dragEnd()"
                >
                  <v-btn
                    color="accent"
                    icon
                    dark
                    @click="previewState(point)"
                  >
                    <v-tooltip top>
                      <v-icon
                        slot="activator"
                        style="display: flex;"
                      >radio_button_unchecked</v-icon>
                      <v-layout row wrap>
                        <v-flex xs12>
                          <span>
                            <b>{{$tc('design.time', 1)}}: </b>
                            {{point.time}} seconds
                          </span>
                        </v-flex>
                      </v-layout>
                    </v-tooltip>
                  </v-btn>
                </drag>
              </swiper-slide>
            </swiper>
          </v-flex>
          <v-flex>
            <v-btn
              slot="button-next"
              class="button-next"
              flat
              icon
            >
              <v-icon>chevron_right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout align-center row wrap>
          <v-flex
            xs12
            md6
            lg6
            text-xs-center
          >
            <drop
              @dragenter="isHovering = true"
              @dragleave="isHovering = false"
              @drop="deleteActiveTimelinePoint()"
            >
              <v-btn
                v-bind:class="{
                  'animated infinite pulse': isDragging && !isHovering,
                  'animated infinite tada': isHovering
                }"
                color="error"
                outline
                large
                block
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </drop>
          </v-flex>
          <v-flex
            xs12
            md6
            lg6
            text-xs-center
          >
            <v-btn
              @click="createTimelinePointModal = true"
              color="accent"
              large
              block
            >
              <v-icon left>add</v-icon>
              POINT
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-dialog v-model="createTimelinePointModal" max-width="500px">
      <v-card>
        <v-card-title primary-title>
          <h3 class="headline mb-0">{{ $t("design.createTimelinePoint") }}</h3>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field
                  v-model.number="timelinePointTime"
                  :label="$tc('design.time', 1)"
                  name="timeline_point_time"
                  placeholder="Seconds"
                  type="number"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click.stop="resetCreateTimelinePointModal()"
            flat
          >{{ $t("general.close") }}</v-btn>
          <v-btn
            @click.stop="createTimelinePoint()"
            color="accent"
          >{{ $t("general.create") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask';
import { Drag, Drop } from 'vue-drag-drop';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

/* eslint-disable import/no-extraneous-dependencies */
import 'swiper/dist/css/swiper.css';
/* eslint-enable */

export default {
  components: {
    Drag,
    Drop,
    swiper,
    swiperSlide,
  },
  directives: { mask },
  data() {
    return {
      createTimelinePointModal: false,
      timelinePointTime: null,
      isDragging: false,
      isHovering: false,
      swiperOption: {
        allowTouchMove: false,
        slidesPerView: 10,
        spaceBetween: 0,
        slidesPerGroup: 3,
        loop: false,
        loopFillGroupWithBlank: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          prevEl: '.button-prev',
          nextEl: '.button-next',
          disabledClass: 'v-btn--disabled',
        },
      },
    };
  },
  computed: {
    timelinePoints: {
      get() {
        return this.$store.getters.getTimelinePoints;
      },
    },
    activeWidget: {
      get() {
        return this.$store.getters.getWidgetByID(this.$store.getters.getActiveWidget);
      },
    },
    widgets: {
      get() {
        return this.$store.getters.getWidgets;
      },
    },
  },
  methods: {
    dragStart(pointIndex) {
      this.isDragging = true;
      this.$store.dispatch('SET_ACTIVE_TIMELINE_POINT', pointIndex);
    },
    dragEnd() {
      this.isDragging = false;
      this.$store.dispatch('SET_ACTIVE_TIMELINE_POINT', null);
    },
    resetCreateTimelinePointModal() {
      this.timelinePointTime = null;
      this.createTimelinePointModal = false;
    },
    createTimelinePoint() {
      const payload = {
        time: this.timelinePointTime,
        layout_id: this.$route.params.id,
      };

      this.$store.dispatch('PUSH_TO_TIMELINE_POINTS', payload);
      this.resetCreateTimelinePointModal();
    },
    deleteActiveTimelinePoint() {
      this.$store.dispatch('DELETE_TIMELINE_POINT', this.$store.getters.getActiveTimelinePoint);
    },
    previewState(point) {
      Object.keys(this.widgets).forEach((key) => {
        const currentState = this.widgets[key].data.states.find(state => state.time === point.time);

        if (currentState !== undefined) {
          this.$events.fire('set-widget-preview-state', {
            id: this.widgets[key].id,
            x: currentState.positionX,
            y: currentState.positionY,
            angle: currentState.rotation,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
#timeline-point-delete-zone {
  border: 2px dashed #bdbdbd;
  border-radius: 1rem;
  background-color: #ffe7e6;
}

#timeline-point-delete-zone.is-dragging {
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #f44336 !important;
}
</style>
